<template>
  <div class="login-container">
    <div class="login-content">
      <div class="login-top">
        <div class="login-header">
          <!--<img alt="logo" class="login-logo" src="../assets/vue-antd-logo.png" />-->
          <span class="login-title">Media Center</span>
        </div>
        <div class="login-desc">
          市县一体融媒体综合管理平台
          <!--全媒体指挥报道系统-->
        </div>
      </div>
      <div class="login-login">
        <a-form @submit="onSubmit" :form="form">
          <a-tabs
            size="large"
            :tabBarStyle="{ textAlign: 'center' }"
            style="padding: 0 2px;"
            defaultActiveKey="2"
          >
            <!--<a-tab-pane tab="手机号登录" key="1">-->
            <!--<a-form-item>-->
            <!--<a-input size="large" placeholder="手机号"-->
            <!--v-decorator="[-->
            <!--'mobile',-->
            <!--{ rules: [{ required: true, message: '手机号不能为空' }] }-->
            <!--]">-->
            <!--<a-icon slot="prefix" type="mobile" />-->
            <!--</a-input>-->
            <!--</a-form-item>-->
            <!--<a-form-item>-->
            <!--<a-row :gutter="8" style="margin: 0 -4px">-->
            <!--<a-col :span="16">-->
            <!--<a-input size="large" placeholder="验证码"-->
            <!--v-decorator="[-->
            <!--'code',-->
            <!--{ rules: [{ required: true, message: '验证码不能为空' }] }-->
            <!--]">-->
            <!--<a-icon slot="prefix" type="mail" />-->
            <!--</a-input>-->
            <!--</a-col>-->
            <!--<a-col :span="8" style="padding-left: 4px">-->
            <!--<a-button style="width: 100%" class="captcha-button" size="large" @click="getCode" :loading="codeLoading">{{ codeStr }}</a-button>-->
            <!--</a-col>-->
            <!--</a-row>-->
            <!--</a-form-item>-->
            <!--</a-tab-pane>-->
            <a-tab-pane tab="账户密码登录" key="2">
              <a-alert
                type="error"
                :closable="true"
                v-show="error"
                :message="error"
                showIcon
                style="margin-bottom: 24px;"
              />
              <a-form-item>
                <a-input
                  size="large"
                  placeholder="账号"
                  v-decorator="[
                    'loginname',
                    { rules: [{ required: true, message: '请输入账户名' }] }
                  ]"
                >
                  <a-icon slot="prefix" type="user" />
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-input
                  size="large"
                  placeholder="密码"
                  type="password"
                  v-decorator="[
                    'password',
                    { rules: [{ required: true, message: '请输入密码' }] }
                  ]"
                >
                  <a-icon slot="prefix" type="lock" />
                </a-input>
              </a-form-item>
            </a-tab-pane>
          </a-tabs>
          <!--<div>-->
          <!--<a-checkbox :checked="true" >记住账号</a-checkbox>-->
          <!--<a style="float: right">忘记密码</a>-->
          <!--</div>-->
          <a-form-item>
            <a-button
              :loading="logging"
              style="width: 100%;margin-top: 24px"
              size="large"
              htmlType="submit"
              type="primary"
              >登录</a-button
            >
          </a-form-item>
          <!--<div>-->
          <!--其他登录方式-->
          <!--<a-icon class="icon" type="alipay-circle" />-->
          <!--<a-icon class="icon" type="taobao-circle" />-->
          <!--<a-icon class="icon" type="weibo-circle" />-->
          <!--<router-link style="float: right" to="/dashboard/workplace" >注册账户</router-link>-->
          <!--</div>-->
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  layout: 'empty',
  name: 'login',
  data() {
    return {
      logging: false,
      codeLoading: false,
      error: '',
      form: this.$form.createForm(this),
      codeStr: '获取验证码',
      loginname: '',
      password: ''
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.logging = true;
          this.form.validateFields((err, values) => {
            if (!err) {
              this.$http.post('oauth/logincheck', values).then(response => {
                this.logging = false;
                if (response.data.state == 200) {
                  this.$store.commit('setToken', response.data.data.token);
                  this.$store.commit('setSiteInfo', response.data.data);
                  window.localStorage.setItem(
                    'token',
                    response.data.data.token
                  );
                  window.localStorage.setItem(
                    'siteinfo',
                    JSON.stringify(response.data.data)
                  );
                  // window.localStorage.setItem('loginInfo', JSON.stringify(response.data.data));
                  this.$message.success('登录成功！');
                  if (typeof this.$route.query.redirect != 'undefined') {
                    window.location.href = this.$route.query.redirect;
                  } else {
                    window.location.href = '/index';
                  }
                } else {
                  this.$message.error(response.data.message, 5);
                }
              });
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  overflow: auto;
  background: #f0f2f5
    url('https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg')
    no-repeat center 110px;
  background-size: 100%;
}
.login-container .login-content {
  padding: 112px 0 24px;
}
.login-container .login-content .login-top {
  text-align: center;
}
.login-container .login-content .login-top .login-header .login-logo {
  height: 44px;
  vertical-align: top;
  margin-right: 16px;
}
.login-container .login-content .login-top .login-header .login-title {
  font-size: 33px;
  color: rgba(0, 0, 0, 0.85);
  font-family: 'Myriad Pro', 'Helvetica Neue', Arial, Helvetica, sans-serif;
  font-weight: 600;
  position: relative;
  top: 2px;
}
.login-container .login-content .login-top .login-desc {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: 12px;
  margin-bottom: 40px;
}
.login-container .login-content .login-login {
  width: 368px;
  margin: 0 auto;
}
</style>
